import { __decorate } from "tslib";
import { ArrayDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
import { BalanceItemPaymentDetailed } from '../BalanceItemDetailed';
import { Payment, Settlement } from './Payment';
export class PaymentGeneral extends Payment {
    constructor() {
        super(...arguments);
        this.balanceItemPayments = [];
        this.iban = null;
        this.ibanName = null;
        /**
         * Only set for administrators with the correct permissions
         */
        this.settlement = null;
        /**
         * Only set for administrators with the correct permissions
         */
        this.transferFee = 0;
        this.serviceFeePayout = 0;
        this.serviceFeeManual = 0;
        this.serviceFeeManualCharged = 0;
        /**
        * Only set for administrators with the correct permissions
        */
        this.stripeAccountId = null;
    }
    get registrations() {
        const registrations = this.balanceItemPayments.flatMap(p => p.balanceItem.registration ? [p.balanceItem.registration] : []);
        // Remove duplicates by id
        return registrations.filter((r, index) => registrations.findIndex(r2 => r2.id == r.id) === index);
    }
    get members() {
        const members = this.balanceItemPayments.flatMap(p => p.balanceItem.member ? [p.balanceItem.member] : []);
        // Remove duplicates by id
        return members.filter((m, index) => members.findIndex(m2 => m2.id == m.id) === index);
    }
    get memberNames() {
        return Formatter.joinLast(this.members.map(m => m.name), ", ", " en ");
    }
    get memberFirstNames() {
        return Formatter.joinLast(this.members.map(m => m.firstName), ", ", " en ");
    }
    get orders() {
        return this.balanceItemPayments.flatMap(p => p.balanceItem.order ? [p.balanceItem.order] : []);
    }
    matchQuery(query) {
        if (super.matchQuery(query)
            || !!this.members.find(member => member.details.matchQuery(query))
            || !!this.orders.find(o => o.matchQuery(query))) {
            return true;
        }
        return false;
    }
    getDetailsHTMLTable() {
        const filtered = this.balanceItemPayments.filter(p => !p.balanceItem.order);
        let str = '';
        if (filtered.length > 0) {
            str += `<table width="100%" cellspacing="0" cellpadding="0" class="email-data-table"><thead><tr><th>Beschrijving</th><th>Prijs</th></tr></thead><tbody>`;
            for (const balanceItemPayment of filtered) {
                str += `<tr><td><h4>${Formatter.escapeHtml(balanceItemPayment.balanceItem.description)}</h4></td><td>${Formatter.escapeHtml(Formatter.price(balanceItemPayment.price))}</td></tr>`;
            }
            return str + "</tbody></table>";
        }
        for (const order of this.orders) {
            str += order.getHTMLTable();
        }
        return str;
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemPaymentDetailed) })
], PaymentGeneral.prototype, "balanceItemPayments", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentGeneral.prototype, "iban", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], PaymentGeneral.prototype, "ibanName", void 0);
__decorate([
    field({ decoder: Settlement, nullable: true })
], PaymentGeneral.prototype, "settlement", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 196 })
], PaymentGeneral.prototype, "transferFee", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], PaymentGeneral.prototype, "serviceFeePayout", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], PaymentGeneral.prototype, "serviceFeeManual", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], PaymentGeneral.prototype, "serviceFeeManualCharged", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 198 })
], PaymentGeneral.prototype, "stripeAccountId", void 0);
//# sourceMappingURL=PaymentGeneral.js.map